
// const tooltip = document.querySelector('.tooltip');

// const avatar_cloud = document.querySelector('.avatar-cloud');
// const avatar_cloud_position = avatar_cloud.getBoundingClientRect().left ;

// // console.log('sfs',avatar_cloud_position)

// document.addEventListener("DOMContentLoaded", () => {
//     const animate_section = document.querySelector('.animate-section');
//     const normalRangeWidth =  animate_section.clientWidth - 100;

//     const avatar_cloud = document.querySelector(".avatar-cloud");

//     function updatePosition() {
//       const pos = avatar_cloud.getBoundingClientRect().left;
//     //   console.log("current left position:", pos);

//       if (normalRangeWidth > pos) {
//         if (pos < 150) {
//             avatar_cloud.classList.add("reverse-position");
//           } else {
//             avatar_cloud.classList.remove("reverse-position");
//           }
//       }

//     }

//     // Initial check
//     updatePosition();

//     // Update when scrolling or resizing
//     window.addEventListener("scroll", updatePosition);
//     window.addEventListener("resize", updatePosition);
//   });
  

// if (normalRangeWidth < 300){

//     tooltip.classList.add('reverse-position');
// }
// console.log(normalRangeWidth);


document.addEventListener('DOMContentLoaded', () => {
    const animateSection = document.querySelector('.animate-section');
    const members = document.querySelectorAll('.member-one');
    const bePartWrapper = document.querySelector('.be-part-wrap .container-wrap');
    if (!animateSection || members.length === 0) return;

    bePartWrapper.addEventListener('mousemove', (e) => {
        // Add throttling for better performance
        let lastMoveTime = 0;
        const throttleDelay = 16; // ~60fps

        const now = Date.now();
        if (now - lastMoveTime < throttleDelay) return;
        lastMoveTime = now;

        const bounds = bePartWrapper.getBoundingClientRect();
        const x = e.clientX - bounds.left;
        const y = e.clientY - bounds.top;

        const containerWidth = animateSection.getClientRects().width;
    })
  
    const leftCornerBound =animateSection.getBoundingClientRect().left;
    const rightCornerBound =animateSection.getBoundingClientRect().right;
    console.log(firstMemberLeft, leftCornerBound, rightCornerBound);
    const cornerThreshold = 50; // px from left/right edges
    
    const checkCorners = () => {
      const sectionRect = animateSection.getBoundingClientRect();
  
      members.forEach((member, index) => {
        const memberRect = member.getBoundingClientRect();
        const leftClass = `member-${index + 1}-left-corner`;
        const rightClass = `member-${index + 1}-right-corner`;
  
        // Remove previous classes
        member.classList.remove(leftClass, rightClass);
  
        // LEFT CORNER: member's left is within threshold of section's left
        if (
          memberRect.left >= sectionRect.left &&
          memberRect.left <= sectionRect.left + cornerThreshold
        ) {
          member.classList.add(leftClass);
        }
  
        // RIGHT CORNER: member's right is within threshold of section's right
        if (
          memberRect.right <= sectionRect.right &&
          memberRect.right >= sectionRect.right - cornerThreshold
        ) {
          member.classList.add(rightClass);
        }
      });
    };
  
    const animate = () => {
      checkCorners();
      requestAnimationFrame(animate);
    };
  
    animate();
  });
  

// (() => {
//   // ====== CONFIG ======
//   const EDGE_PX = 100; // left/right trigger zone

//   // Manual positions per member class (add as needed)
// const POS = {
//     'member-one':   { left: 12,  top: -8,  tx: 0,  ty: 0 },
//     'member-two':   { left: 24,  top: -16, tx: 0,  ty: 0 },
//     'member-three': { left: 100,   top: -24, tx: -8, ty: 0 },
//     'member-four':  { left: 10,  top: -10, tx: 0,  ty: 0 },
//     'member-five':  { left: 20,  top: -20, tx: 0,  ty: 0 },
//     'member-six':   { left: 30,  top: -30, tx: 0,  ty: 0 },
//     'member-seven': { left: 40,  top: -40, tx: 0,  ty: 0 },
//     'member-eight': { left: 50,  top: -50, tx: 0,  ty: 0 },
//     'member-nine':  { left: 60,  top: -60, tx: 0,  ty: 0 },
//     'member-ten':   { left: 70,  top: -70, tx: 0,  ty: 0 },
//     'member-eleven': { left: 80, top: -80, tx: 0,  ty: 0 },
// };

//   const section = document.querySelector('.animate-section');
//   if (!section) return;

//   // Cache items + tooltips
//   const items = Array.from(section.querySelectorAll('.member-item'))
//     .map(item => {
//       const memberClass = Array.from(item.classList).find(c => c.startsWith('member-'));
//       const tooltip = item.querySelector('.tooltip');
//       return { item, tooltip, memberClass };
//     })
//     .filter(x => x.tooltip && x.memberClass);

//   // Make sure tooltip can be absolutely positioned without reflowing siblings
//   items.forEach(({ item, tooltip }) => {
//     if (getComputedStyle(item).position === 'static') item.style.position = 'relative';
//     tooltip.style.transition = 'left 140ms ease-out, top 140ms ease-out, transform 140ms ease-out';
//     tooltip.style.willChange = 'left, top, transform';
//   });

//   let rect = section.getBoundingClientRect();
//   const updateRect = () => { rect = section.getBoundingClientRect(); };
//   window.addEventListener('resize', updateRect, { passive: true });
//   window.addEventListener('scroll', updateRect, { passive: true });

//   // Apply or clear manual positions
//   function setManualPositions(active) {
//     for (const { tooltip, memberClass } of items) {
//       const cfg = POS[memberClass];
//       if (!cfg) continue;

//       if (active) {
//         tooltip.style.position = 'absolute';
//         tooltip.style.left = (cfg.left ?? 0) + 'px';
//         tooltip.style.top  = (cfg.top  ?? 0) + 'px';
//         const tx = (cfg.tx ?? 0) + 'px';
//         const ty = (cfg.ty ?? 0) + 'px';
//         tooltip.style.transform = `translate(${tx}, ${ty})`;
//       } else {
//         // Revert to default (as defined in your CSS theme)
//         tooltip.style.left = '';
//         tooltip.style.top = '';
//         tooltip.style.transform = '';
//         // keep absolute only if your default relies on it; otherwise:
//         tooltip.style.position = '';
//       }
//     }
//   }

//   // Edge detection
//   let raf = null;
//   let shouldActivate = false;

//   function evaluate(x, y) {
//     // pointer must be vertically inside the section
//     if (y < rect.top || y > rect.bottom) return false;

//     const localX = x - rect.left;
//     const fromLeft = localX;
//     const fromRight = rect.width - localX;

//     const inLeftEdge = fromLeft >= 0 && fromLeft <= EDGE_PX;
//     const inRightEdge = fromRight >= 0 && fromRight <= EDGE_PX;
// console.log("firstMemberLeft", rect.left, rect.right);
//     return inLeftEdge || inRightEdge;


//   }

//   function onPointerMove(e) {
//     const next = evaluate(e.clientX, e.clientY);
//     if (next === shouldActivate) return;
//     shouldActivate = next;
//     if (raf) return;
//     raf = requestAnimationFrame(() => {
//       setManualPositions(shouldActivate);
//       raf = null;
//     });
//   }

//   function onLeave() {
//     shouldActivate = false;
//     setManualPositions(false);
//   }

//   section.addEventListener('pointermove', onPointerMove, { passive: true });
//   section.addEventListener('pointerleave', onLeave, { passive: true });

//   // Initial state (off)
//   setManualPositions(false);
// })();
